

const ProgressDisplay = ({ message }: { message: string | null; }) => {

    return (
        <div className="progress-display__backdrop">
            <div className="progress-display__container">
                <p className="progress-display__text">{message}</p>
                <div className="file-loader__box">
                    <div className="file-loader" />
                </div>
            </div>
        </div>
    );
};

export default ProgressDisplay;